import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getOTPData } from '../../features/Auth/authSlice';

const PrivateRoute = ({ component: Component,  ...rest }) => {
	const selector = useSelector(getOTPData)
	return (
		<Route
			{...rest}
			render={(props) => ((localStorage.getItem("tokitoken") || Object.keys(selector).length > 0) ? <Component {...props} /> : <Redirect to="/" />)}
		/>
	);
};

export default PrivateRoute;
